import { ReactNode } from 'react';

export interface ISnackbarArgs {
  children: ReactNode;
  childrenClassName?: string;
  type: SnackbarType;
}

export interface ISnackbarItem extends ISnackbarArgs {
  id: string;
}

export enum SnackbarType {
  SUCCESS,
  WARNING,
}

export type SnackbarShowFn = (options: ISnackbarArgs) => string;

export type SnackbarCloseFn = (id: string) => void;

export type SnackbarTypedFn = (text: string) => string;

export interface ISnackbarState {
  snackItems: ISnackbarItem[];
  snackbarClose: SnackbarCloseFn;
  snackbarShow: SnackbarShowFn;
  snackbarShowSuccess: SnackbarTypedFn;
  snackbarShowWarning: SnackbarTypedFn;
}
